import { cloneElement } from "preact";
import { range } from "d3-array";
import {
  WindRose10,
  WindRose22,
  WindRose45,
  WindRose90,
} from "./DemoWindRoses";

const makeDegreeDirections = (step) => range(0, 360, step).map((d) => `${d}°`);

// const degreeSteps = [10, 22.5, 45, 90];
// const filterCardinalDirections = (cardinalDirections, number) =>
//   cardinalDirections.filter((d, i) => i % number == 0);

const cardinalDirections = [
  "N",
  "NNE",
  "NE",
  "ENE",
  "E",
  "ESE",
  "SE",
  "SSE",
  "S",
  "SSW",
  "SW",
  "WSW",
  "W",
  "WNW",
  "NW",
  "NNW",
];

const DirectionButton = ({
  onSetDirections,
  directions,
  amount,
  disabled,
  DemoWindRose,
}) => (
  // or define directions here?
  <button
    onClick={() => onSetDirections(directions)}
    disabled={disabled}
    class="btn flex-grow m-1 md:m-2 bg-gray-400"
    title={`${amount} directions`}
  >
    <span class="text-xl">{amount}</span> <br />
    <span class="text-xs text-gray-700 tracking-wide degree">
      Step: {360 / amount}
    </span>
    <div class="mt-2 w-16 h-16 md:w-48 md:h-48 mx-auto">
      {cloneElement(DemoWindRose, { directions })}
    </div>
  </button>
);

function DefineDirections({
  isCardinal,
  directions,
  onToggleCardinal,
  onSetDirections,
  onConfirmDirections,
}) {
  return (
    <div class="define-data-card">
      <h3 class="h3">Directions</h3>

      <div class="bg-gray-300 px-8 py-2 my-4 rounded flex items-center shadow">
        <label for="cardinal" class="font-semibold">
          Use{" "}
          <abbr title="A named direction like North and South-East">
            cardinal
          </abbr>{" "}
          directions
        </label>
        <input
          type="checkbox"
          onChange={onToggleCardinal}
          class="form-checkbox ml-4 h-5 w-5"
          id="cardinal"
          checked={isCardinal}
        />
      </div>

      <div class="mb-4 bg-gray-300 px-4 py-2 w-full rounded shadow">
        <h4 class="h4 text-gray-900">Select number of directions</h4>
        <div class="flex flex-initial flex-wrap">
          {/* Make component with props {steps : num} {direction : array} directions = cardinal ? cardinalDirections : makeDegreeDirections(steps) */}
          <DirectionButton
            onSetDirections={onSetDirections}
            amount={4}
            directions={
              isCardinal ? ["N", "E", "S", "W"] : makeDegreeDirections(90) // step = 90 and amount = 4 is double tho but it works
            }
            DemoWindRose={<WindRose90 />}
          />
          <DirectionButton
            onSetDirections={onSetDirections}
            amount={8}
            directions={
              isCardinal
                ? ["N", "NE", "E", "SE", "S", "SW", "W", "NW"]
                : makeDegreeDirections(45)
            }
            DemoWindRose={<WindRose45 />}
          />
          {/* <DirectionButton
            onSetDirections={onSetDirections}
            amount={12}
            directions={makeDegreeDirections(360/12)}
            DemoWindRose={<br />}
          /> */}
          <DirectionButton
            onSetDirections={onSetDirections}
            amount={16}
            directions={
              isCardinal ? cardinalDirections : makeDegreeDirections(22.5)
            }
            DemoWindRose={<WindRose22 />}
          />
          <DirectionButton
            disabled={isCardinal}
            onSetDirections={onSetDirections}
            amount={36}
            directions={makeDegreeDirections(10)}
            DemoWindRose={<WindRose10 />}
          />
        </div>
      </div>

      <p class="bg-gray-300 px-4 md:px-8 py-2 my-4 rounded flex items-center shadow">
        <span class="font-bold">Selected directions: </span>
        {directions.length ? (
          directions.join(", ")
        ) : (
          <span class="text-gray-600">Choose directions first...</span>
        )}
      </p>
      <div class="flex justify-end pt-2">
        <button class="btn btn-blue my-4" onClick={onConfirmDirections}>
          Confirm directions
        </button>
      </div>
    </div>
  );
}

export { DefineDirections };
